import { H2, H5 } from "../../../../AbstractElements";
import { FormGroup, Input, Label } from "reactstrap";
import { ContactNameWizard, ContactNameWizardPlaceholder, EnterYourEmailPasswordToLoginWizard, FirstNameWizard, FirstNameWizardPlaceholder, LastNameWizard, LastNameWizardPlaceholder, SignUpToAccount } from "../../../../Constant";
import { RegisterWizardForm } from "../../../../Type/Pages";

const PersonalForm = ({ formValue, getUserData }: RegisterWizardForm) => {
  const { contactNumber, lastName, firstName } = formValue;

  return (
    <div id="step-1" className="content">
      <div className="wizard-title">
        <H2>{SignUpToAccount}</H2>
        <H5 className="text-muted mb-4">{EnterYourEmailPasswordToLoginWizard}</H5>
      </div>
      <div className="login-main">
        <div className="theme-form">
          <FormGroup className="mb-3">
            <Label htmlFor="name" check>{FirstNameWizard}</Label>
            <Input value={firstName} name="firstName" onChange={getUserData} id="name" type="text" placeholder={FirstNameWizardPlaceholder} required />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label htmlFor="lname" check>{LastNameWizard}</Label>
            <Input value={lastName} name="lastName" onChange={getUserData} id="lname" type="text" placeholder={LastNameWizardPlaceholder} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label htmlFor="contact" check>{ContactNameWizard}</Label>
            <Input value={contactNumber} onChange={getUserData} name="contactNumber"  id="contact" type="number" placeholder={ContactNameWizardPlaceholder} />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default PersonalForm;
